import React, { useEffect, useState } from 'react'
import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css';
import { Link } from 'react-router-dom';
import { homeCelebrityClosetList } from '../services/General-service';

const optioncelebriy = {
    loop: true,
    // margin: 10,
    nav: true,
    dots: false,
    responsive: {
        0: {
            items: 2.2
        },
        600: {
            items: 3
        },
        1000: {
            items: 4
        }
    }
};

function ItemLink({ url, children }) {
    const href = typeof url === 'string' ? url.trim() : '';
    if (!href) {
        return <>{children}</>;
    }

    if (/^https?:\/\//i.test(href)) {
        return (
            <a href={href} target="_blank" rel="noopener noreferrer">
                {children}
            </a>
        );
    }

    return <Link to={href}>{children}</Link>;
}

function Celebriy({ccloset, sectionTitle}) {
    const [items, setItems] = useState([]);
    const [apiTitle, setApiTitle] = useState('');

    useEffect(() => {
        if (!ccloset) return;

        homeCelebrityClosetList()
            .then((data) => {
                const list = Array.isArray(data?.data) ? data.data : [];
                setApiTitle(data?.section_ttile || data?.section_title || '');
                setItems(
                    list
                        .map((item) => ({
                            id: item?.id,
                            src: item?.banner_image || item?.image || item?.thumbnail || '',
                            url: item?.url || '',
                            firstContent: item?.first_content || item?.title || '',
                            secondContent: item?.second_content || '',
                        }))
                        .filter((item) => item.src)
                );
            })
            .catch((error) => {
                console.error('Error fetching celebrity closet:', error);
                setItems([]);
                setApiTitle('');
            });
    }, [ccloset]);

    if (!ccloset || items.length === 0) return null;

    return (
        <div>
            <div className='App'>
                <div className="BreakPointContainer">
                    <div className="CarouselSectionContainer celebrity-closet">
                        <div className="layout row justify-space-between align-center text-left SectionTitle">
                            <h1 className='m-t-0 m-b-0 demi-bold w-auto'> {apiTitle || sectionTitle || 'CELEBRITY CLOSET'} </h1>
                            <Link to="/category" className='ViewAllUrlsLink orat-color-hover h5 demi-bold w-auto'>VIEW ALL</Link>
                        </div>
                        <div className="layout">
                            <div className="flex left-align-slick xs12">
                                <OwlCarousel className='owl-theme' loop nav {...optioncelebriy}>
                                    {items.map((item, index) => (
                                        <div className='item' key={item.id || index}>
                                            <div className="CarouselSection category">
                                                <div className="prel Gutter">
                                                    <ItemLink url={item.url}>
                                                        <div className="DynamicHeightLoaderWrapper" style={{ paddingTop: '112%' }}>
                                                            <div className="DynamicHeightLoader layout row align-center justify-center" style={{ paddingTop: '32%' }}>
                                                                <img src={item.src} alt={item.firstContent || 'logo'} className='img-resp DynamicHeightLoaderImage' style={{ padding: '0px' }} />
                                                            </div>
                                                            <div className="animated-bg-placeholder"></div>
                                                        </div>
                                                        <div className="ImageTextDetail CategoryImageTextDetail">
                                                            <label className="h4 ImageTextLabelTop m-t-5 demi-bold"> {item.firstContent} </label>
                                                            <label className="h6 ellipsis ImageTextLabelBottom block font-normal">{item.secondContent}</label>
                                                        </div>
                                                    </ItemLink>
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </OwlCarousel>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default Celebriy
